import { useState } from 'react';
import { X, Mail } from 'lucide-react';
import { WaitlistForm } from '@/components/WaitlistForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';

const DISMISS_KEY = 'forvisibility_coming_soon_dismissed';

export function ComingSoonBanner() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === 'true');
  const [showWaitlist, setShowWaitlist] = useState(false);

  if (dismissed) return null;

  return (
    <>
      <div className="flex items-center justify-center gap-2 bg-warning px-4 py-2 text-sm font-medium text-warning-foreground">
        <span>🚧 For Visibility is in early access — demo account only.</span>
        <button
          onClick={() => setShowWaitlist(true)}
          className="flex items-center gap-1 underline hover:no-underline"
        >
          <Mail className="h-3 w-3" />
          Sign up for launch updates
        </button>
        <button
          onClick={() => {
            localStorage.setItem(DISMISS_KEY, 'true');
            setDismissed(true);
          }}
          className="ml-2 flex h-5 w-5 items-center justify-center rounded-full hover:bg-warning-foreground/20"
          aria-label="Dismiss"
        >
          <X className="h-3 w-3" />
        </button>
      </div>

      <Dialog open={showWaitlist} onOpenChange={setShowWaitlist}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Get early access</DialogTitle>
            <DialogDescription>
              Sign up to be notified when For Visibility launches. No spam — just launch updates.
            </DialogDescription>
          </DialogHeader>
          <WaitlistForm />
        </DialogContent>
      </Dialog>
    </>
  );
}
